"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var messenger = function messenger(frame) {
  return function () {
    return {
      respond: function respond(context, message) {
        return context.send(message);
      },
      send: function send(channel, message) {
        return frame.send(channel, message);
      }
    };
  };
};

var _default = messenger;
exports.default = _default;